import { Form, Input, theme } from 'antd';
import React, { useContext } from 'react';
import { ProfileContext, ProgramContext, UserDataContext } from '../../../contexts/context';
import library from '../../../helpers/library';
import ApplyOrCancel from '../../../components/ApplyOrCancel';
const { useToken } = theme;

const getEmailFormField = (authorizedUser) => {
  return  [
    {
      name: 'email',
      value: authorizedUser.email,
    },
  ]
}

const EmailForm = ({name, emailState, setEmailState, emailOrPaswordFormFinish}) => {
  const { authorizedUser, features } = useContext(UserDataContext)
  const { profileUpdating, curEditingForm, setCurEditingForm } = useContext(ProfileContext)
  const fields = getEmailFormField(authorizedUser);
  const [ emailFormInstance ] = Form.useForm();
  const { token } = useToken();

  const isEditing = curEditingForm === name;

  const applyChanges = () => {
    emailFormInstance.submit();
  }

  const cancelChanges = () => {
    setCurEditingForm('');
    setEmailState();
  }

  const handleValuesChange = (changedValues, _allValues) => {
    setCurEditingForm('emailForm')
    const newEmailField = {
      name: 'email',
      value: changedValues.email,
    }
    setEmailState([newEmailField])
  }


  return (
    <div
      style={{
        backgroundColor: token.colorBgContainer,
        padding: '5% 5% 2.5%',
        borderRadius: '10px',
        marginBottom: '5%',
      }}
    >
      <Form
        fields={isEditing ? emailState : fields}
        layout='horizontal'
        labelCol={{span: 10}}
        wrapperCol={{span: 14}}
        labelAlign='left'
        onValuesChange={handleValuesChange}
        onFinish={emailOrPaswordFormFinish}
        form={emailFormInstance}
        // preserve={false}
      >
        <Form.Item
          name='email'
          label='Email'
          rules={[{ required: true, message: library.validationErrorMessages.requiredField }]}
          disabled={true}
        >
          <Input
            disabled={!features.canChangeEmail || (profileUpdating && !isEditing)}
            // disabled={ profileUpdating && !isEditing}
          />
        </Form.Item>
        <ApplyOrCancel isEdit={isEditing} applyChanges={applyChanges} cancelChanges={cancelChanges} loading={profileUpdating} />
      </Form>
    </div>
  );
};

export default EmailForm;
